import type { PlanDto } from "./plan.dto";

import { api } from "../core/api";

export async function getPlans(
  key?: string,
  page: number = 1,
  per: number = 20
): Promise<PlanDto[]> {
  const response = await api.get("/api/v1/subscriptions", {
    params: {
      key,
      page,
      per,
    },
  });

  return response.data.data || [];
}

export async function getPayments(page = 1) {
  const res = await api.get<PaymentsPaginator>(
    `/api/v1/subscriptions/payments?page=${page}`
  );
  const paginator = res.data;
  return paginator;
}

interface PaymentsPaginator {
  meta: { current_page: number; items_per_age: number; total_pages: number };
  data: PaymentDto[];
}
interface PaymentDto {
  id: string;
  external_id: string;
  user_subscription_id: string;
  status: string;
  value: number;
  invoice_uri: string;
  created_at: string;
  updated_at: string;
  due_date: string;
  subscription?: { id: string; name: string };
}

export async function createSubscription(dto: CreateSubscriptionDto) {
  const res = await api.post("/api/v1/subscriptions/subscribe", {
    subscription: dto,
  });
  const data = res.data.data as { user_subscription: UserSubscriptionDto };
  return data;
}

export interface CreateSubscriptionDto {
  billing_type: "pix" | "credit_card";
  subscription_id: string;
  user_info: {
    cpf_cnpj: string;
    phone?: string;
    street?: string;
    street_number?: string;
    postal_code?: string;
    province?: string;
    complement?: string;
  };
  payment_info?: {
    credit_card: {
      holder_name: string;
      number: string;
      ccv: string;
      expiry_month: string;
      expiry_year: string;
    };
    credit_card_holder_info: {
      name: string;
      email: string;
      cpf_cnpj: string;
      postal_code: string;
      address_number: string;
      address_complement?: string;
      mobile_phone: string;
    };
  };
  installment_count?: number;
}

export interface UserSubscriptionDto {
  billing_type: "pix" | "credit_card";
  status: string;
}

export async function getSubscription() {
  const res = await api.get("/api/v1/subscriptions/details");
  const data = res.data.data as SubscriptionDetailsDto;
  return data;
}

interface SubscriptionDetailsDto {
  user_subscription: {
    billing_type: "pix" | "credit_card";
    status: string; // created / waiting_payment / paid / overdue
  };
  payments?: {
    status: string;
    pix_copy_paste: string;
    pix_base64: string;
  };
}
